// import React, { useEffect, useMemo, useState } from "react";
// import { db } from "../firebase";
// import {
//   collection,
//   getDocs,
//   Timestamp,
// } from "firebase/firestore";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//   faSearch,
//   faClipboardList,
//   faPlus,
// } from "@fortawesome/free-solid-svg-icons";
// import { Modal, Box, Typography, Button } from "@mui/material";

// interface SerialAgentDoc {
//   id: string;
//   count?: number;
//   createdAt?: Timestamp;
//   createdAtLocal?: Timestamp;
//   date?: string;
//   time?: string;
//   serials?: string[];
//   userId?: string;
// }

// interface UserData {
//   id: string;
//   uid?: string;
//   fullName?: string;
//   phoneNumber?: string;
//   AccountLevel?: string;
//   accountType?: string;
//   profileImageUrl?: string;
// }

// interface SerialAgentRow extends SerialAgentDoc {
//   user?: UserData | null;
// }

// const SerialAgent: React.FC = () => {
//   const [rows, setRows] = useState<SerialAgentRow[]>([]);
//   const [loading, setLoading] = useState(true);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [openModal, setOpenModal] = useState(false);
//   const [selectedRow, setSelectedRow] = useState<SerialAgentRow | null>(null);

//   const fetchData = async () => {
//     setLoading(true);
//     try {
//       const serialSnap = await getDocs(collection(db, "SerialAgent"));
//       const usersSnap = await getDocs(collection(db, "users"));

//       const usersMap = new Map<string, UserData>();

//       usersSnap.forEach((userDoc) => {
//         const data = userDoc.data() as Omit<UserData, "id">;
//         const userObj: UserData = {
//           id: userDoc.id,
//           ...data,
//         };

//         if (data.uid) {
//           usersMap.set(data.uid, userObj);
//         }

//         usersMap.set(userDoc.id, userObj);
//       });

//       const serialRows: SerialAgentRow[] = [];

//       serialSnap.forEach((docSnap) => {
//         const data = docSnap.data() as Omit<SerialAgentDoc, "id">;

//         serialRows.push({
//           id: docSnap.id,
//           ...data,
//           user: data.userId ? usersMap.get(data.userId) || null : null,
//         });
//       });

//       serialRows.sort((a, b) => {
//         const aMs = a.createdAt?.toMillis?.() ?? 0;
//         const bMs = b.createdAt?.toMillis?.() ?? 0;
//         return bMs - aMs;
//       });

//       setRows(serialRows);
//     } catch (error) {
//       console.error("Error fetching SerialAgent data:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchData();
//   }, []);

//   const q = searchQuery.trim().toLowerCase();

//   const filteredRows = useMemo(() => {
//     return rows.filter((row) => {
//       if (!q) return true;

//       const fullName = (row.user?.fullName ?? "").toLowerCase();
//       const phoneNumber = (row.user?.phoneNumber ?? "").toLowerCase();
//       const accountLevel = (row.user?.AccountLevel ?? "").toLowerCase();
//       const accountType = (row.user?.accountType ?? "").toLowerCase();
//       const date = (row.date ?? "").toLowerCase();
//       const time = (row.time ?? "").toLowerCase();
//       const serials = (row.serials ?? []).join(" ").toLowerCase();

//       return (
//         fullName.includes(q) ||
//         phoneNumber.includes(q) ||
//         accountLevel.includes(q) ||
//         accountType.includes(q) ||
//         date.includes(q) ||
//         time.includes(q) ||
//         serials.includes(q)
//       );
//     });
//   }, [rows, q]);

//   const openSerialsModal = (row: SerialAgentRow) => {
//     setSelectedRow(row);
//     setOpenModal(true);
//   };

//   const closeSerialsModal = () => {
//     setSelectedRow(null);
//     setOpenModal(false);
//   };

//   const formatDateTime = (timestamp?: Timestamp) => {
//     if (!timestamp) return "-";
//     const date = timestamp.toDate();

//     return date.toLocaleString("en-US", {
//       year: "numeric",
//       month: "2-digit",
//       day: "2-digit",
//       hour: "2-digit",
//       minute: "2-digit",
//       second: "2-digit",
//       hour12: true,
//     });
//   };

//   return (
//     <div
//       className="w-full max-w-none mx-auto bg-white rounded-xl shadow-lg"
//       style={{ width: 1400, direction: "rtl" }}
//     >
//       <div className="max-w-full flex items-center justify-between bg-[#262d34] text-white px-6 py-3 rounded-t-lg shadow-md">
//         <h1
//           className="text-xl font-bold flex-1 text-right"
//           style={{ fontFamily: "Tajawal, sans-serif" }}
//         >
//           سجلات رفع السيريلات للوكلاء
//         </h1>

//         <div className="flex items-center bg-gray-100 rounded-full px-4 py-1 w-80 shadow-md">
//           <FontAwesomeIcon icon={faSearch} className="text-gray-500 ml-2" />
//           <input
//             type="text"
//             placeholder="البحث بالاسم أو الهاتف أو السيريال أو التاريخ..."
//             className="bg-transparent focus:outline-none w-full text-sm text-gray-700 py-1"
//             style={{ fontFamily: "Tajawal, sans-serif", textAlign: "right" }}
//             value={searchQuery}
//             onChange={(e) => setSearchQuery(e.target.value)}
//           />
//         </div>
//       </div>

//       {loading ? (
//         <p style={{ padding: 20, fontFamily: "Tajawal, sans-serif" }}>
//           جاري التحميل...
//         </p>
//       ) : (
//         <div className="table-container" style={{ overflowX: "auto" }}>
//           <table className="product-table" style={{ width: "100%" }}>
//             <thead className="color-table">
//               <tr>
//                 <th>#</th>
//                 <th>المستخدم</th>
//                 <th>رقم الهاتف</th>
//                 <th>نوع الحساب</th>
//                 <th>Account Level</th>
//                 <th>عدد السيريلات</th>
//                 <th>التاريخ</th>
//                 <th>الوقت</th>
//                 <th>وقت الرفع</th>
//                 <th>الإجراءات</th>
//               </tr>
//             </thead>

//             <tbody>
//               {filteredRows.map((row, index) => (
//                 <tr key={row.id}>
//                   <td>{index + 1}</td>

//                   <td>
//                     <div
//                       style={{
//                         display: "flex",
//                         alignItems: "center",
//                         gap: "10px",
//                         justifyContent: "flex-start",
//                       }}
//                     >
//                       <img
//                         src={
//                           row.user?.profileImageUrl ||
//                           "https://via.placeholder.com/45?text=User"
//                         }
//                         alt={row.user?.fullName || "User"}
//                         style={{
//                           width: 45,
//                           height: 45,
//                           borderRadius: "50%",
//                           objectFit: "cover",
//                           border: "1px solid #ddd",
//                         }}
//                       />
//                       <span style={{ fontSize: 15 }}>
//                         {row.user?.fullName || "غير معروف"}
//                       </span>
//                     </div>
//                   </td>

//                   <td>{row.user?.phoneNumber || "-"}</td>
//                   <td>{row.user?.accountType || "-"}</td>
//                   <td>{row.user?.AccountLevel || "-"}</td>
//                   <td>{row.count ?? row.serials?.length ?? 0}</td>
//                   <td>{row.date || "-"}</td>
//                   <td>{row.time || "-"}</td>
//                   <td>{formatDateTime(row.createdAt)}</td>

//                   <td>
//                     <button
//                       className="icon-button"
//                       onClick={() => openSerialsModal(row)}
//                       title="عرض السيريلات"
//                       style={{
//                         border: "none",
//                         background: "transparent",
//                         cursor: "pointer",
//                         fontSize: 18,
//                       }}
//                     >
//                       <FontAwesomeIcon icon={faClipboardList} />
//                     </button>
//                   </td>
//                 </tr>
//               ))}

//               {filteredRows.length === 0 && (
//                 <tr>
//                   <td colSpan={10} style={{ textAlign: "center", padding: 20 }}>
//                     لا توجد بيانات
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>
//       )}

//       <Modal open={openModal} onClose={closeSerialsModal}>
//         <Box
//           sx={{
//             position: "absolute",
//             top: "50%",
//             left: "50%",
//             transform: "translate(-50%, -50%)",
//             width: 700,
//             maxHeight: "80vh",
//             overflowY: "auto",
//             bgcolor: "white",
//             borderRadius: "12px",
//             boxShadow: 24,
//             p: 3,
//             direction: "rtl",
//           }}
//         >
//           <Typography
//             variant="h6"
//             sx={{
//               textAlign: "center",
//               mb: 2,
//               fontFamily: "Tajawal, sans-serif",
//               fontWeight: "bold",
//             }}
//           >
//             السيريلات المرفوعة
//           </Typography>

//           <div style={{ marginBottom: 16, textAlign: "center" }}>
//             <strong>المستخدم:</strong> {selectedRow?.user?.fullName || "-"}{" "}
//             &nbsp; | &nbsp;
//             <strong>العدد:</strong> {selectedRow?.serials?.length || 0}
//           </div>

//           <div style={{ textAlign: "left", marginBottom: 16 }}>
//             <Button
//               variant="contained"
//               startIcon={<FontAwesomeIcon icon={faPlus} />}
//               onClick={() => {}}
//               sx={{ fontFamily: "Tajawal, sans-serif" }}
//             >
//               إضافة الكل
//             </Button>
//           </div>

//           <table style={{ width: "100%", borderCollapse: "collapse" }}>
//             <thead>
//               <tr style={{ background: "#f3f4f6" }}>
//                 <th style={cellHead}>#</th>
//                 <th style={cellHead}>السيريال</th>
//                 <th style={cellHead}>الإجراء</th>
//               </tr>
//             </thead>
//             <tbody>
//               {(selectedRow?.serials || []).map((serial, index) => (
//                 <tr key={`${serial}-${index}`}>
//                   <td style={cellBody}>{index + 1}</td>
//                   <td style={cellBody}>{serial}</td>
//                   <td style={cellBody}>
//                     <Button
//                       variant="outlined"
//                       size="small"
//                       onClick={() => {}}
//                       sx={{ fontFamily: "Tajawal, sans-serif" }}
//                     >
//                       إضافة
//                     </Button>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>

//           <div style={{ textAlign: "center", marginTop: 20 }}>
//             <Button
//               variant="contained"
//               color="secondary"
//               onClick={closeSerialsModal}
//               sx={{ fontFamily: "Tajawal, sans-serif" }}
//             >
//               إغلاق
//             </Button>
//           </div>
//         </Box>
//       </Modal>
//     </div>
//   );
// };

// const cellHead: React.CSSProperties = {
//   border: "1px solid #ddd",
//   padding: "10px",
//   textAlign: "center",
//   fontWeight: "bold",
// };

// const cellBody: React.CSSProperties = {
//   border: "1px solid #ddd",
//   padding: "10px",
//   textAlign: "center",
// };

// export default SerialAgent;



import React, { useEffect, useMemo, useState } from "react";
import { db } from "../firebase";
import {
  collection,
  onSnapshot,
  Timestamp,
  query,
  orderBy,
} from "firebase/firestore";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSearch,
  faClipboardList,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";
import { Modal, Box, Typography, Button } from "@mui/material";

interface SerialAgentDoc {
  id: string;
  count?: number;
  createdAt?: Timestamp;
  createdAtLocal?: Timestamp;
  date?: string;
  time?: string;
  serials?: string[];
  userId?: string;
}

interface UserData {
  id: string;
  uid?: string;
  fullName?: string;
  phoneNumber?: string;
  AccountLevel?: string;
  accountType?: string;
  profileImageUrl?: string;
}

interface SerialAgentRow extends SerialAgentDoc {
  user?: UserData | null;
}

const SerialAgent: React.FC = () => {
  const [rows, setRows] = useState<SerialAgentRow[]>([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState<SerialAgentRow | null>(null);

  useEffect(() => {
    let serialDocs: SerialAgentDoc[] = [];
    let usersDocs: UserData[] = [];

    const buildRows = () => {
      const usersMap = new Map<string, UserData>();

      usersDocs.forEach((user) => {
        if (user.uid) {
          usersMap.set(user.uid, user);
        }
        usersMap.set(user.id, user);
      });

      const mergedRows: SerialAgentRow[] = serialDocs.map((row) => ({
        ...row,
        user: row.userId ? usersMap.get(row.userId) || null : null,
      }));

      mergedRows.sort((a, b) => {
        const aMs = a.createdAt?.toMillis?.() ?? 0;
        const bMs = b.createdAt?.toMillis?.() ?? 0;
        return bMs - aMs;
      });

      setRows(mergedRows);
      setLoading(false);
    };

    const serialQuery = query(
      collection(db, "SerialAgent"),
      orderBy("createdAt", "desc")
    );

    const unsubscribeSerials = onSnapshot(
      serialQuery,
      (snapshot) => {
        serialDocs = snapshot.docs.map((docSnap) => ({
          id: docSnap.id,
          ...(docSnap.data() as Omit<SerialAgentDoc, "id">),
        }));
        buildRows();
      },
      (error) => {
        console.error("Error listening to SerialAgent:", error);
        setLoading(false);
      }
    );

    const unsubscribeUsers = onSnapshot(
      collection(db, "users"),
      (snapshot) => {
        usersDocs = snapshot.docs.map((docSnap) => ({
          id: docSnap.id,
          ...(docSnap.data() as Omit<UserData, "id">),
        }));
        buildRows();
      },
      (error) => {
        console.error("Error listening to users:", error);
        setLoading(false);
      }
    );

    return () => {
      unsubscribeSerials();
      unsubscribeUsers();
    };
  }, []);

  const q = searchQuery.trim().toLowerCase();

  const filteredRows = useMemo(() => {
    return rows.filter((row) => {
      if (!q) return true;

      const fullName = (row.user?.fullName ?? "").toLowerCase();
      const phoneNumber = (row.user?.phoneNumber ?? "").toLowerCase();
      const accountLevel = (row.user?.AccountLevel ?? "").toLowerCase();
      const accountType = (row.user?.accountType ?? "").toLowerCase();
      const date = (row.date ?? "").toLowerCase();
      const time = (row.time ?? "").toLowerCase();
      const serials = (row.serials ?? []).join(" ").toLowerCase();

      return (
        fullName.includes(q) ||
        phoneNumber.includes(q) ||
        accountLevel.includes(q) ||
        accountType.includes(q) ||
        date.includes(q) ||
        time.includes(q) ||
        serials.includes(q)
      );
    });
  }, [rows, q]);

  const openSerialsModal = (row: SerialAgentRow) => {
    setSelectedRow(row);
    setOpenModal(true);
  };

  const closeSerialsModal = () => {
    setSelectedRow(null);
    setOpenModal(false);
  };

  const formatDateTime = (timestamp?: Timestamp) => {
    if (!timestamp) return "-";
    const date = timestamp.toDate();

    return date.toLocaleString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    });
  };

  return (
    <div
      className="w-full max-w-none mx-auto bg-white rounded-xl shadow-lg"
      style={{ width: 1400, direction: "rtl" }}
    >
      <div className="max-w-full flex items-center justify-between bg-[#262d34] text-white px-6 py-3 rounded-t-lg shadow-md">
        <h1
          className="text-xl font-bold flex-1 text-right"
          style={{ fontFamily: "Tajawal, sans-serif" }}
        >
          سجلات رفع السيريلات للوكلاء
        </h1>

        <div className="flex items-center bg-gray-100 rounded-full px-4 py-1 w-80 shadow-md">
          <FontAwesomeIcon icon={faSearch} className="text-gray-500 ml-2" />
          <input
            type="text"
            placeholder="البحث بالاسم أو الهاتف أو السيريال أو التاريخ..."
            className="bg-transparent focus:outline-none w-full text-sm text-gray-700 py-1"
            style={{ fontFamily: "Tajawal, sans-serif", textAlign: "right" }}
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>
      </div>

      {loading ? (
        <p style={{ padding: 20, fontFamily: "Tajawal, sans-serif" }}>
          جاري التحميل...
        </p>
      ) : (
        <div className="table-container" style={{ overflowX: "auto" }}>
          <table className="product-table" style={{ width: "100%" }}>
            <thead className="color-table">
              <tr>
                <th>#</th>
                <th>المستخدم</th>
                <th>رقم الهاتف</th>
                <th>نوع الحساب</th>
                <th>Account Level</th>
                <th>عدد السيريلات</th>
                <th>التاريخ</th>
                <th>الوقت</th>
                <th>وقت الرفع</th>
                <th>الإجراءات</th>
              </tr>
            </thead>

            <tbody>
              {filteredRows.map((row, index) => (
                <tr key={row.id}>
                  <td>{index + 1}</td>

                  <td>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        justifyContent: "flex-start",
                      }}
                    >
                      <img
                        src={
                          row.user?.profileImageUrl ||
                          "https://via.placeholder.com/45?text=User"
                        }
                        alt={row.user?.fullName || "User"}
                        style={{
                          width: 45,
                          height: 45,
                          borderRadius: "50%",
                          objectFit: "cover",
                          border: "1px solid #ddd",
                        }}
                      />
                      <span style={{ fontSize: 15 }}>
                        {row.user?.fullName || "غير معروف"}
                      </span>
                    </div>
                  </td>

                  <td>{row.user?.phoneNumber || "-"}</td>
                  <td>{row.user?.accountType || "-"}</td>
                  <td>{row.user?.AccountLevel || "-"}</td>
                  <td>{row.count ?? row.serials?.length ?? 0}</td>
                  <td>{row.date || "-"}</td>
                  <td>{row.time || "-"}</td>
                  <td>{formatDateTime(row.createdAt)}</td>

                  <td>
                    <button
                      className="icon-button"
                      onClick={() => openSerialsModal(row)}
                      title="عرض السيريلات"
                      style={{
                        border: "none",
                        background: "transparent",
                        cursor: "pointer",
                        fontSize: 18,
                      }}
                    >
                      <FontAwesomeIcon icon={faClipboardList} />
                    </button>
                  </td>
                </tr>
              ))}

              {filteredRows.length === 0 && (
                <tr>
                  <td colSpan={10} style={{ textAlign: "center", padding: 20 }}>
                    لا توجد بيانات
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}

      <Modal open={openModal} onClose={closeSerialsModal}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 700,
            maxHeight: "80vh",
            overflowY: "auto",
            bgcolor: "white",
            borderRadius: "12px",
            boxShadow: 24,
            p: 3,
            direction: "rtl",
          }}
        >
          <Typography
            variant="h6"
            sx={{
              textAlign: "center",
              mb: 2,
              fontFamily: "Tajawal, sans-serif",
              fontWeight: "bold",
            }}
          >
            السيريلات المرفوعة
          </Typography>

          <div style={{ marginBottom: 16, textAlign: "center" }}>
            <strong>المستخدم:</strong> {selectedRow?.user?.fullName || "-"}{" "}
            &nbsp; | &nbsp;
            <strong>العدد:</strong> {selectedRow?.serials?.length || 0}
          </div>

          <div style={{ textAlign: "left", marginBottom: 16 }}>
            <Button
              variant="contained"
              startIcon={<FontAwesomeIcon icon={faPlus} />}
              onClick={() => {}}
              sx={{ fontFamily: "Tajawal, sans-serif" }}
            >
              إضافة الكل
            </Button>
          </div>

          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ background: "#f3f4f6" }}>
                <th style={cellHead}>#</th>
                <th style={cellHead}>السيريال</th>
                <th style={cellHead}>الإجراء</th>
              </tr>
            </thead>
            <tbody>
              {(selectedRow?.serials || []).map((serial, index) => (
                <tr key={`${serial}-${index}`}>
                  <td style={cellBody}>{index + 1}</td>
                  <td style={cellBody}>{serial}</td>
                  <td style={cellBody}>
                    <Button
                      variant="outlined"
                      size="small"
                      onClick={() => {}}
                      sx={{ fontFamily: "Tajawal, sans-serif" }}
                    >
                      إضافة
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <div style={{ textAlign: "center", marginTop: 20 }}>
            <Button
              variant="contained"
              color="secondary"
              onClick={closeSerialsModal}
              sx={{ fontFamily: "Tajawal, sans-serif" }}
            >
              إغلاق
            </Button>
          </div>
        </Box>
      </Modal>
    </div>
  );
};

const cellHead: React.CSSProperties = {
  border: "1px solid #ddd",
  padding: "10px",
  textAlign: "center",
  fontWeight: "bold",
};

const cellBody: React.CSSProperties = {
  border: "1px solid #ddd",
  padding: "10px",
  textAlign: "center",
};

export default SerialAgent;